import React from 'react';
import { Instagram, Facebook, Youtube, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-darker border-t border-dark-lighter py-12" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-26">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-27">
            <img src="https://cdn.magicpatterns.com/uploads/chtLiN7NP86jg8BJETW5iX/mike-curry-logo.png" alt="Mike Curry Coaching" className="h-16 w-auto mb-6 opacity-90" data-id="element-28" />
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-29">
              Helping high-achieving men overcome addiction and disconnection to
              unlock their true potential.
            </p>
          </div>

          {/* Links */}
          <div className="col-span-1" data-id="element-30">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-31">
              Explore
            </h4>
            <ul className="space-y-3" data-id="element-32">
              {['Home', 'Services', 'Podcast', 'About', 'Contact'].map(item => <li key={item} data-id="element-33">
                    <a href="#" className="text-gray-400 hover:text-gold transition-colors text-sm" data-id="element-34">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1" data-id="element-35">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-36">
              Location
            </h4>
            <div className="flex items-start text-gray-400 text-sm" data-id="element-37">
              <MapPin className="w-5 h-5 mr-2 text-gold flex-shrink-0" data-id="element-38" />
              <span data-id="element-39">
                Tucson, Arizona
                <br data-id="element-40" />
                Available Worldwide Virtual
              </span>
            </div>
          </div>

          {/* Social */}
          <div className="col-span-1" data-id="element-41">
            <h4 className="text-white font-bold uppercase tracking-wider mb-6" data-id="element-42">
              Connect
            </h4>
            <div className="flex space-x-4" data-id="element-43">
              {[Instagram, Facebook, Youtube].map((Icon, i) => <a key={i} href="#" className="bg-dark p-3 rounded-full hover:bg-gold hover:text-black text-white transition-all duration-300" data-id="element-44">
                  <Icon size={20} data-id="element-45" />
                </a>)}
            </div>
          </div>
        </div>

        <div className="border-t border-dark-lighter pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-46">
          <p data-id="element-47">
            &copy; {new Date().getFullYear()} Mike Curry Coaching. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-48">
            <a href="#" className="hover:text-gray-400" data-id="element-49">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-50">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}